import { Component, EventEmitter, Output } from '@angular/core';
import { HelpersService } from '../../../../core/services/helpers.service';

import { DocumentoAllegato } from '../../../models/documento-allegato';
import { FileData } from '../../../models/file-data';
import { EXTENSIONS, mimeExtensionMap } from '../../file-preview/eml/eml-preview.component';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { Router } from '@angular/router';
import { UserProfileFlagStore } from 'src/app/utility/store/user-profile-flag';


declare var closeModal: any;

@Component({
    selector: '[doc_version_history]',
  templateUrl: 'document-version-history.component.html'
})

export class DocumentVersionHistoryComponent {

  fascicolo: any;
  tipoPratica: string;
  documento: DocumentoAllegato;
  filesData: FileData[];
  @Output()
  onReturn = new EventEmitter();

  constructor(private helpersService: HelpersService,private router: Router) {
    this.helpersService = helpersService;
  }

  init(documento, fascicolo) {
    this.documento = documento;
    this.fascicolo = fascicolo;
    this.helpersService.retrieveVersionHistory(this.documento.id)
    .subscribe((response: any) => {
      // Ordina i file ricevuti in base alla versione (dalla più alta alla più bassa)
      this.filesData = response.filesData.sort((a, b) => {
        // Converte la versione del file 'a' in un array [major, minor]
        const [majorA, minorA] = this.parseVersion(a.versione);
        // Converte la versione del file 'b' in un array [major, minor]
        const [majorB, minorB] = this.parseVersion(b.versione);

        // Confronto tra le versioni:
         // 1. Se la parte major è diversa, ordino in base a quella (decrescente)
        if (majorA !== majorB) return majorB - majorA;
        return minorB - minorA;
      });
      // console.log('Files ordinati per versione:');
      // this.filesData.forEach(f => console.log(`file: ${f.nomeFile}, versione: ${f.versione}`));
    });
  }

  private parseVersion(version: string | number | undefined): [number, number] {
    // Se la versione non esiste, considerala come 1.0
    if (!version) return [1, 0]; // default 1.0
    // Se la versione è un numero (es. 1.2 come number), separa major e minor
    if (typeof version === 'number') {
      const major = Math.floor(version); // parte intera → major
      const minor = Math.round((version - major) * 10); // parte decimale → minor
      return [major, minor]; 
    }
    // Se la versione è una stringa (es. "1.2")
    const parts = version.split('.');
    const major = parseInt(parts[0], 10) || 1; // converte la prima parte, default 1
    const minor = parseInt(parts[1], 10) || 0; // converte la seconda parte, default 0
    return [major, minor]; // restituisce [major, minor] per l'ordinamento
  }

  downloadDocByIdDocumentale(ref: string) {
    this.helpersService.downloadDocumentoByIdDocumentaleVersionHistory(ref).subscribe();
  }

  isFilePresent(documento): boolean {
    return documento?.missingFile !== true;
  }

  canViewFile(file: FileData){
    let maxPreviewSize = this.findMaxSizeByContentype(file.contentType);
    // controllo che il contenuto del file non superi la dimensione massima consentita
    // console.log(documento.contentSize, Number(maxPreviewSize))
    if(file.contentSize > Number(!!maxPreviewSize ? maxPreviewSize : file.contentSize)) {
      return false;
    };
    return file && 
    file.nomeFile && (
      file.nomeFile.includes(".pdf") || 
      file.nomeFile.includes(".eml") || 
      file.nomeFile.includes(".zip") || 
      file.nomeFile.includes(".p7m")
    );
  }
  
  checkMaxLimitExceeded(documento: FileData):boolean {
    let maxPreviewSize = this.findMaxSizeByContentype(documento.contentType);
    if(documento.contentSize > Number(!!maxPreviewSize ? maxPreviewSize : documento.contentSize)) {
      return true;
    }
    return false;
  }
  
  findMaxSizeByContentype(contentType) {
    let maxPreviewSize = UserProfileFlagStore.getInstance().MAX_PREVIEW_FILE_SIZE;
    if(!maxPreviewSize) return null;
    for (const key in maxPreviewSize) {
        if (maxPreviewSize[key].contentType === contentType) {
            return maxPreviewSize[key].maxSize;
        }
    }
    return maxPreviewSize['default'].maxSize;
  }

  viewDoc(documento: FileData) {
    let mimeTypes = mimeExtensionMap;
    this.previewNavigate(documento, mimeTypes[documento.contentType]);
  }
  
  previewNavigate(file: FileData, contentType: string) {
    let fullUrl = null;
    let urlTree = null;
    let urlSerialized = null;
    switch (contentType) {
      case EXTENSIONS.EML:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_EML_FILE_PREVIEW_REF, file.refDocumentale]);
        break;
      case EXTENSIONS.ZIP:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_ZIP_FILE_PREVIEW_REF, file.refDocumentale]);
        break;
      case EXTENSIONS.PDF:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_PDF_FILE_PREVIEW_REF, file.refDocumentale]);
        break;
      case EXTENSIONS.P7M:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_PDF_FILE_PREVIEW_REF, this.documento.id, 'p7m', file.versione]);
        break;
      default:
        break;
    }
    if(!urlTree) return;
    urlSerialized = this.router.serializeUrl(urlTree);
    fullUrl = `${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#${urlSerialized}?nomeFile=${file.nomeFile}`;
    // console.log('previewNavigate → URL completo da aprire:', fullUrl);
    window.open(fullUrl, '_blank');
  }

}
